import { redirect, RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { DDE_MENU_ICONS } from '@/router/icons'
import { GolfPricingView } from '@/views/GolfPricing/GolfPricingView'
import LeaderboardView from '@/views/GolfPricing/Tournament/Leaderboard/LeaderboardView'
import TeamView from '@/views/GolfPricing/Tournament/Leaderboard/Team/TeamView'
import OddsDataView from '@/views/GolfPricing/Tournament/OddsData/OddsDataView'
import TournamentView from '@/views/GolfPricing/Tournament/TournamentView'

export const golfPricingRoutes: RouteObject[] = [
  {
    label: 'Golf Pricing',
    path: 'golf-pricing',
    icon: DDE_MENU_ICONS.GOLF_PRICING,

    platforms: [PLATFORM.DDE],
    children: [
      { index: true, element: <GolfPricingView />, platforms: [PLATFORM.DDE] },
      {
        path: ':tournamentId/*',
        element: <TournamentView />,
        children: [
          {
            index: true,
            loader: () => redirect('leaderboard'),
            platforms: [PLATFORM.DDE]
          },
          {
            path: 'leaderboard',
            element: <LeaderboardView />,
            platforms: [PLATFORM.DDE]
          },
          {
            path: 'leaderboard/:teamNo',
            element: <TeamView />,
            platforms: [PLATFORM.DDE]
          },
          {
            path: 'odds-data',
            element: <OddsDataView />,
            platforms: [PLATFORM.DDE]
          }
        ]
      }
    ]
  }
]
